import React from 'react';
import Sidebar from './Sidebar';
import MaintenanceBanner from './MaintenanceBanner';
import DevBadge from './DevBadge';
import HelpCenterPanel from './HelpCenterPanel';
import { useAuth } from '../contexts/AuthContext';

const AppLayout = ({ children }) => {
  const { user } = useAuth();

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />

      <div className="flex min-w-0 flex-1 overflow-hidden">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          {user?.is_admin && <MaintenanceBanner />}

          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto">{children}</main>
        </div>

        <HelpCenterPanel />
      </div>

      <DevBadge />
    </div>
  );
};

export default AppLayout;
